<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttLabel="from_supplier_name" [ttModel]="setting.from_supplier_name" ttReadonly></tt-input>
            <tt-button-goto ttText="freightratesets_new" ttGoto="freightratesetcreate" [ttGotoParms]="{ cust_no: custNo }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListRateSets"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <tt-input ttLabel="from_supplier_name" [ttModel]="setting.from_supplier_name" ttReadonly></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="freightratesets_new" ttGoto="freightratesetcreate" [ttGotoParms]="{ cust_no: custNo }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-4 p-5" [ttData]="itemsListRateSets"></tt-list>
    </div>
</tt-page>
